import type { RootState } from '@appStore/store'

import { appSelectors } from '@appStore/reducers/app'
import { createSelector } from '@reduxjs/toolkit'
import { mapping } from 'actions/mapping'
import { connectorApi } from 'api/connector/api'
import { useState } from 'react'
import { useAppSelector } from 'shared/hooks'

const selectCampaignsTeams = createSelector(
	(state: RootState) => state.campaignsTeams.campaignsTeams,
	mapping.campaignsForTable
)

// TODO: replace to TeamCampaignStatistics
export function useTempProps() {
	const campaignsTeams = useAppSelector(selectCampaignsTeams)
	const [loaderStatistics, setLoaderStatistics] = useState(false)
	const [orderby, setOrderby] = useState('created desc')

	const localAppProfile = useAppSelector(appSelectors.appProfile)
	const [_, { isLoading }] = connectorApi.useSignInUnderTeamMemberMutation()

	return {
		campaignsTeams,
		loaderStatistics: isLoading || loaderStatistics,
		localAppProfile,
		orderby,
		setLoaderStatistics,
		setOrderby
	}
}
